export default __webpack_public_path__ + "static/media/fmd1.bf661237.webp";